module.exports = __webpack_public_path__ + "img/adicionar-camada.69c047c4.svg";